import Content, { ContentNS } from "content/content";
import SuccessBanner from "features/shared/components/banners/success-banner/SuccessBanner";
import useGeneralAnalytics from "features/shared/hooks/analytics/useGeneralAnalytics";
import PageHeader from "features/shared/styles/page-header/PageHeader.styled";
import Body from "features/shared/styles/typography/Body.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import ChecklistResolutionStatus from "models/checklist/checklist-resolution-status";
import { FC } from "react";
import { useAppStore } from "store/store";

import PassengersList from "./components/select-passenger-list/SelectPassengerList";
import StyledSelectPassengerPage from "./styles/StyledSelectPassengerPage.styled";

const SelectPassengerPage: FC = () => {
  useAppStore((state) => state.locale);
  useGeneralAnalytics();
  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.ui });
  const paxSessions = useAppStore((state) => state.paxSessions);
  const allResolved = paxSessions.every(
    (pax) =>
      pax.checklist.resolutionStatus === ChecklistResolutionStatus.ReadyToFly
  );

  return (
    <StyledSelectPassengerPage>
      {allResolved ? <SuccessBanner /> : null}
      <PageHeader>
        <TertiaryHeader>{text("passengers-list-title")}</TertiaryHeader>
        <Body>{text("passengers-list-subtitle")}</Body>
      </PageHeader>
      <PassengersList />
    </StyledSelectPassengerPage>
  );
};

export default SelectPassengerPage;
